<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { Menu } from "lucide-vue-next";
import { cn } from "@/utils/shadcn";
import { Button } from "@/components/ui/button";
import { useSidebar } from "./utils";

const props = defineProps<{
  class?: HTMLAttributes["class"];
}>();

const { toggleSidebar } = useSidebar();
</script>

<template>
  <Button
    data-sidebar="trigger"
    data-slot="sidebar-trigger"
    variant="ghost"
    size="icon"
    :class="cn('h-7 w-7', props.class)"
    @click="toggleSidebar"
  >
    <Menu />
    <span class="sr-only">Toggle Sidebar</span>
  </Button>
</template>
